<template>
    <v-dialog v-model="dialog.show" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                class="mx-2"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                fab
                small
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            dark
                        >
                            mdi-plus
                        </v-icon>
                    </template>
                    create new composite customer
                </v-tooltip>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">new composite customer</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                  <v-row>
                      <v-col cols="12" sm="12">
                          <v-text-field v-model="compositeCustomerItem.name" label="name" />
                      </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12">
                        <v-text-field
                          v-model="compositeCustomerItem.description"
                          label="description"
                        ></v-text-field>
                    </v-col>
                    </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-switch
                          v-model="compositeCustomerItem.isActive"
                          label="is active"
                          class="pa-3"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                          v-model="compositeCustomerItem.isNative"
                          label="is native"
                          class="pa-3"
                      />
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialog.show=false"
                  :disabled="dialog.saving"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    :disabled="dialog.saving"
                    :loading="dialog.saving"
                    @click="save"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'CompositeCustomerForm',
  data: () => ({
    dialog: {
      saving: false,
      show: false,
    },

    compositeCustomerItem: {
      id: null,
      name: '',
      description: '',
      isActive: true,
      isNative: false,
    },
  }),
  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    save() {
      this.dialog.saving = false;

      this.$requestHelpers
        .post('api/admin/compositeCustomer',
          {
            name: this.compositeCustomerItem.name,
            description: this.compositeCustomerItem.description,
            is_active: this.compositeCustomerItem.isActive,
            is_native: this.compositeCustomerItem.isNative,
          }).then((response) => {
          this.$emit('create', response.data.result);

          this.compositeCustomerItem.name = '';
          this.compositeCustomerItem.description = '';
          this.compositeCustomerItem.id = null;
          this.compositeCustomerItem.isActive = true;
          this.compositeCustomerItem.isNative = false;

          this.dialog.show = false;
        }).finally(() => {
          this.dialog.saving = false;
        });
    },
  },
};
</script>
